import React, { useState } from 'react';
import Loader from '../../../components/Common/Loader';

interface FlipBookAccessEmailProps {
  submit?: (email: string) => Promise<void>;
}

const FlipBookAccessEmail: React.FC<FlipBookAccessEmailProps> = ({
                                                                   submit
                                                                 }: FlipBookAccessEmailProps) => {
  const [loader, setLoader] = useState<boolean>(false);
  const [email, setEmail] = useState<string>('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoader(true);
    if (submit) {
      await submit(email);
    }
    setLoader(false);
  };

  return (
    <div className={`flex flex-col`}>
      <p className="text-[#0a215c] mb-6">In order to view flip book please enter your email</p>
      <form onSubmit={handleSubmit} className="flex flex-col gap-4">
        <input
          type="email"
          placeholder="Enter your email here..."
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          className="border border-gray-300 rounded-lg p-3"
        />
        <div className="flex justify-end mt-2">
          <button
            className="flex justify-center bg-storyblueSecondLightText text-white hover:text-white font-bold rounded-full text-base px-4 py-2"
            type="submit"
          >
            Continue
            {loader && (<Loader loader={loader} />)}
          </button>
        </div>
      </form>
    </div>
  );
};

export default FlipBookAccessEmail;
